module.exports = __webpack_public_path__ + "img/rebelart.c3541094.png";